import { JsonObject } from 'json2typescript';
import { MessagesResponseInterface } from '../interfaces/messages-response.interface';

@JsonObject('MessagesResponseModel')
export class MessagesResponseModel implements MessagesResponseInterface {
  Date?: string;
  DocFileName?: string;
  DocId?: string;
  DocType?: string;
  DownloadDate?: string;
  HtlmMessage?: string;
  HtmlId?: string;
  HtmlReadedDate?: string;
  IsDownloaded?: boolean;
  IsHtmlReaded?: boolean;
  IsReaded?: boolean;
  MessageId: string;
  MessageTypeId: number;
  ReadedDate: string;
  Sender: string;
  TextId: string;
  TextMessage: string;
  UserCode: string;
  UserFullName: string;
  UserId: string;
}
